module.exports = __webpack_public_path__ + "media/images/home_one-dd1eb25a26af1b3e438adf5ec8b14c0c.jpg";